<template>
    <div id="pay">
        <div>
            <el-card>
                <el-form ref="form" :model="form"
                         :label-width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'100px':'300px'"
                         size="small">
                    <el-form-item label="选择推送方式"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                        <el-select v-model="form.type" placeholder="请选择推送方式"
                                   :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                            <el-option label="极光" value="jPush"></el-option>
                            <el-option label="友盟" value="uMeng"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Appkey" v-show="form.type=='jPush'"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                        <el-input v-model="form.appkey"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                    </el-form-item>
                    <el-form-item label="App Master Secret" v-show="form.type=='jPush'"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                        <el-input v-model="form.app_master_secret"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                    </el-form-item>
                    <el-form-item label="环境" v-show="form.type=='jPush'"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                        <el-select v-model="form.enviroment" placeholder="请选择方式"
                                   :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                            <el-option label="开发" value="0"></el-option>
                            <el-option label="生产" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-divider content-position="left" v-if="form.type=='uMeng'">安卓设置</el-divider>
                    <el-form-item label="Appkey" v-show="form.type=='uMeng'">
                        <el-input v-model="form.android.appkey"></el-input>
                    </el-form-item>
                    <el-form-item label="Umeng Message Secret" v-show="form.type=='uMeng'">
                        <el-input v-model="form.android.umeng_message_secret"></el-input>
                    </el-form-item>
                    <el-form-item label="App Master Secret" v-show="form.type=='uMeng'">
                        <el-input v-model="form.android.app_master_secret"></el-input>
                    </el-form-item>
                    <el-form-item label="包名" v-show="form.type=='uMeng'">
                        <el-input v-model="form.android.default_activity"></el-input>
                    </el-form-item>
                    <el-divider content-position="left" v-if="form.type=='uMeng'">ios设置</el-divider>
                    <el-form-item label="Appkey" v-show="form.type=='uMeng'">
                        <el-input v-model="form.ios.appkey"></el-input>
                    </el-form-item>
                    <el-form-item label="App Master Secret" v-show="form.type=='uMeng'">
                        <el-input v-model="form.ios.app_master_secret"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">保存</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
    </div>
</template>

<script>
    export default {
        name: "pay",
        data() {
            return {
                form: {
                    type: '',
                    appkey: '',
                    app_master_secret: '',
                    enviroment: '',
                    android: {
                        appkey: '',
                        umeng_message_secret: '',
                        app_master_secret: '',
                        default_activity: '',
                    },
                    ios: {
                        appkey: '',
                        app_master_secret: '',
                    }
                },
            }
        },
        created() {
            this.getData()
        },
        methods: {
            getData() {
                this.$axios.post('admin/config/push', '').then((res) => {
                    this.form = res.data;
                });
            },
            onSubmit() {
                // console.log(this.form);
                this.$axios.post('admin/config/push_set', {config: this.form}).then((res) => {
                    this.$message.success('成功');
                    this.getData();
                    this.visible = false
                });
            },
        }
    }
</script>

<style scoped>

</style>